import axios from 'axios';
import { dateFormatter } from '../dateFormatter/formatter';
import { costFormatter } from '../costFormatter/costFormatter';
import {cookieHelper} from '../cookieHelper';

import { getMaintenaceSessionId } from '../urlConstructor/initMaintenanceSession';
import { maintenanceCatalog } from '../urlConstructor/maintenanceCatalog';
import { maintenanceSending } from '../urlConstructor/maintenanceSending';

export default  {
    state: {
        maintenance: {
            sessionId: null,
            unforeseenSessionExpiration: false,
            sessionExpirationTime: null,
            mobilities: [],
            advisers: [],
            dateTimes: {},
            dealers: [],
            types: [
                'require',
                'scheduledMaintenance',
                'recommend',
                'recommendedMaintenance',
                'promo',
                'care',
                'diagnostics',
                'accessories',
                'specialOffers'
            ],
            services: {},
            reviewCampaigns: [],
            vehicleInfo:[],
            cities: null,
            currency: null
        },

        maintenanceLimit: {
            expirationTime: 0,
            limit: 0
        },

        maintenanceSelected: {
            vehicleInfo: {
                model: '',
                air: '',
                fuel: '',
                engine: '',
                year: '',
                mileage: '',
                vin: ''
            },
            vehicleInfoEntryType: '',
            dealer: '',
            adviser: null,
            mobility: null,
            date: '',
            time: '',
            services: {
                required: [],
                recommend: [],
                specialOffers: []
            },
            reviewCampaigns: [],
            additionalRequirements: null,
            clientInfo: {
                firstName: '',
                middleName: '',
                lastName: '',
                phone: '',
                email: ''
            },
            unsentClientInfo: {
                firstName: '',
                middleName: '',
                lastName: '',
                phone: '',
                email: ''
            },
            finished: false
        },
    },



    getters: {
        maintenanceConfig(state) {
            return {
                headers: {
                    'JLR-Session-Id': state.maintenance.sessionId
                }
            }
        },
        maintenanceFormattedTime(state) {
            const params = {
                date: state.maintenanceSelected.date,
                time: state.maintenanceSelected.time,
                locale: state.locale
            };
            return dateFormatter(params);
        },
        maintenanceFormattedServices(state) {
            const services = [];
            const servicesInState = state.maintenanceSelected.services;
            for (const group in servicesInState) {
                if(servicesInState[group].forEach) {
                    servicesInState[group].forEach(service => {
                        services.push(service);
                    });
                }
            }
            return services;
        },
        maintenanceTotalCost(state, getters) {
            let totalCost = 0;
            const currencySymbol = state.maintenance.currency ? state.maintenance.currency.symbol : '';

            getters.maintenanceFormattedServices.forEach(service => {
                const actualServicePrice = service.is_discount ? service.discount_price : service.price;
                totalCost += actualServicePrice;
            });

            return `${costFormatter(totalCost)} ${currencySymbol}`;
        }
    },



    mutations: {
        setMaintenanceLimit: function(state, payload) {
            state.maintenanceLimit = payload;
        },
        setMaintenanceSessionId: function (state, payload) {
            state.maintenance.sessionId = payload;
            state.maintenance.unforeseenSessionExpiration = false;
        },
        setMaintenanceSessionExpirationTime: function (state, payload) {
            state.maintenance.sessionExpirationTime = Date.now() + payload * 1000;
        },

        changeMaintenanceAdvisers: function(state, payload) {
            state.maintenance.advisers = payload;
        },
        changeMaintenanceMobilities: function(state, payload) {
            state.maintenance.mobilities = payload;
        },
        changeMaintenanceDateTimes: function(state, payload) {
            state.maintenance.dateTimes = payload;
        },
        changeMaintenanceDealers: function(state, payload) {
            state.maintenance.dealers = payload;
        },
        changeMaintenanceServices: function(state, payload) {
            state.maintenance.services = payload;
        },
        changeMaintenanceCurrency: function(state, payload) {
            state.maintenance.currency = payload;
        },
        changeMaintenanceReviewCampaigns: function(state, payload) {
            state.maintenance.reviewCampaigns = payload;
        },

        setMaintenanceCities: function(state, payload) {
            state.maintenance.cities = payload;
        },


        setMaintenanceVehicleInfo: function (state, payload) {
            state.maintenanceSelected.vehicleInfo = payload.data;
            state.maintenanceSelected.vehicleInfoEntryType = payload.entryType;
        },
        setMaintenanceDealer: function (state, payload) {
            state.maintenanceSelected.dealer = payload;
        },
        setMaintenanceDateTime: function (state, payload) {
            state.maintenanceSelected.date = payload.date;
            state.maintenanceSelected.time = payload.time;
        },
        setMaintenanceAdviser: function (state, payload) {
            state.maintenanceSelected.adviser = payload;
        },
        setMaintenanceMobility: function (state, payload) {
            state.maintenanceSelected.mobility = payload;
        },
        setMaintenanceServices: function (state, payload) {
            state.maintenanceSelected.services = payload;
        },
        setMaintenanceReviewCampaigns: function (state, payload) {
            state.maintenanceSelected.reviewCampaigns = payload;
        },
        setMaintenanceAdditionalRequirements: function (state, payload) {
            state.maintenanceSelected.additionalRequirements = payload;
        },
        setMaintenanceClientInfo: function (state, payload) {
            state.maintenanceSelected.clientInfo = payload;
        },


        finishedMaintenanceBooking: function (state) {
            state.maintenanceSelected.finished = true;
        },
        clearMaintenanceDealer: function(state) {
            state.maintenanceSelected.dealer = '';
        },
        clearMaintenanceServices: function(state) {
            state.maintenanceSelected.services = [];
        },
        clearMaintenanceDateTime: function(state) {
            state.maintenanceSelected.date = '';
            state.maintenanceSelected.time = {};
        },
        clearMaintenanceForm: function (state) {
            state.maintenance.sessionId = null;
            state.maintenance.sessionExpirationTime = null;
            state.maintenance.unforeseenSessionExpiration = false;

            state.maintenanceSelected = {
                vehicleInfo: {
                    model: '',
                    air: '',
                    fuel: '',
                    engine: '',
                    year: '',
                    mileage: '',
                    vin: ''
                },
                vehicleInfoEntryType: '',
                dealer: '',
                adviser: null,
                mobility: null,
                date: '',
                time: '',
                services: {
                    required: [],
                    recommend: [],
                    specialOffers: []
                },
                reviewCampaigns: [],
                additionalRequirements: null,
                clientInfo: {
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    phone: '',
                    email: ''
                },
                unsentClientInfo: {
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    phone: '',
                    email: ''
                },
                finished: false
            }
        },
    },


    actions: {
        setMaintenanceLimit(context) {
            const url = maintenanceCatalog.getLimit();
            return axios.get(url).then(res => {
                const expirationTime = Date.now()/1000 + res.data.limit_lifetime;
                const limitInfo = {
                    expirationTime: expirationTime,
                    limit: res.data.request_limit
                };
                context.commit('setMaintenanceLimit', limitInfo);
            })
        },
        setMaintenanceSessionId(context) {
            const urlParams = {
                brandId: context.state.brandId,
                visitorId: cookieHelper.get('JLR_WIDGET_VISITOR_ID')
            };

            if (context.state.dealerId) {
                urlParams.dealerId = context.state.dealerId;
            }

            const url = getMaintenaceSessionId(urlParams);

            return axios.get(url).then(res => {
                context.commit('setMaintenanceSessionId', res.data.session_id);
                context.commit('setMaintenanceSessionExpirationTime', res.data.lifetime);
            })
        },

        changeMaintenanceDealerInfo(context) {
            const urlParams = {
                brandId: context.state.brandId,
                centerId: context.state.maintenanceSelected.dealer.id
            };

            const url = maintenanceCatalog.getDealerInfo(urlParams);

            axios.get(url, context.getters.maintenanceConfig)
                .then(res => {
                    const info = res.data.center;
                    context.commit('changeMaintenanceAdvisers', info.advisers);
                    context.commit('changeMaintenanceMobilities', info.mobility_variants);
                })
        },
        changeMaintenanceDateTimes(context) {
            const urlParams = {
                brandId: context.state.brandId,
                centerId: context.state.maintenanceSelected.dealer.id
            };

            if(context.state.maintenanceSelected.adviser) {
                urlParams.adviserId = context.state.maintenanceSelected.adviser.id
            }

            const url = maintenanceCatalog.getTimeSlots(urlParams);

            return axios.get(url, context.getters.maintenanceConfig)
                .then(res => {
                    context.commit('changeMaintenanceDateTimes', res.data.time_slots);
                })
                .catch(err => {
                    context.commit('changeMaintenanceDateTimes', {});
                    reject()
                })
        },
        changeMaintenanceDealers(context, payload) {
            const urlParams = {
                brandId: context.state.brandId,
                dealerId: context.state.dealerId,
                placeId: payload.placeId,
                cityId: payload.cityId
            };
            const url = maintenanceCatalog.getDealers(urlParams);

            return axios.get(url, context.getters.maintenanceConfig)
                .then(res => {
                    context.commit('changeMaintenanceDealers', res.data.dealers);
                })
                .catch(err => {
                    context.commit('changeMaintenanceDealers', []);
                    reject()
                })
        },
        changeMaintenanceServices(context) {
            const urlParams = {
                brandId: context.state.brandId,
                centerId: context.state.maintenanceSelected.dealer.id
            };
            const url = maintenanceCatalog.getPackages(urlParams);
            return axios.get(url, context.getters.maintenanceConfig).then(res => {
                context.commit('changeMaintenanceServices', res.data.packages);
                context.commit('changeMaintenanceCurrency', res.data.currency);
            }).catch(err => {
                context.commit('changeMaintenanceServices', null);
                context.commit('changeMaintenanceCurrency', null);
            });
        },
        changeMaintenanceReviewCampaigns(context) {
            const urlParams = {
                brandId: context.state.brandId,
            };
            const url = maintenanceCatalog.getReviewCampaigns(urlParams);
            return axios.get(url, context.getters.maintenanceConfig).then(res => {
                context.commit('changeMaintenanceReviewCampaigns', res.data.campaigns);
            }).catch(err => {
                context.commit('changeMaintenanceReviewCampaigns', null);
            });
        },
        setMaintenanceCities(context){
            if( context.state.dealerId ) {
                const urlParams = {
                    brandId: context.state.brandId,
                    dealerId: context.state.dealerId
                };

                const url = maintenanceCatalog.getCities(urlParams);

                return axios.get(url, context.getters.maintenanceConfig)
                    .then(res => {
                        context.commit('setMaintenanceCities', res.data.cities);
                    })
                    .catch(() => {
                        context.commit('setMaintenanceCities', null);
                    })
            } else {
                context.commit('setMaintenanceCities', null);
            }
        },

        setMaintenanceDateTime(context, payload){
            const urlParams = {
                brandId: context.state.brandId
            };

            const url = maintenanceSending.sendTimeSlot(urlParams);

            const data = {
                time_start: payload.time.start,
                time_end: payload.time.end,
                date: payload.date,
                center: context.state.maintenanceSelected.dealer.id,
                mobility_variant: context.state.maintenanceSelected.mobility.id
            };

            if (context.state.maintenanceSelected.adviser) {
                data.adviser = context.state.maintenanceSelected.adviser.id;
            }

            return axios.post(url, data, context.getters.maintenanceConfig)
                .then(res => {
                    context.commit('setMaintenanceDateTime', payload)
                })
        },

        setMaintenanceDealer({commit}, payload){
            commit('setMaintenanceDealer', payload)
        },
        setMaintenanceServices(context, payload){
            const urlParams = {
                brandId: context.state.brandId
            };

            const url = maintenanceSending.sendServicePackages(urlParams);

            const servicesData = {
                packages: payload.servicesId || [],
                campaigns: payload.reviewCampaignsId || [],
                message: payload.additionalRequirements
            };

            return axios.post(url, servicesData, context.getters.maintenanceConfig).then(() => {
                context.commit('setMaintenanceServices', payload.services);
                context.commit('setMaintenanceReviewCampaigns', payload.reviewCampaigns);
                context.commit('setMaintenanceAdditionalRequirements', payload.additionalRequirements);
            })
        },
        setMaintenanceClientInfo(context, payload){
            const urlParams = {
                brandId: context.state.brandId
            };

            const url = maintenanceSending.sendClientInfo(urlParams);

            const userData = {
                first_name: payload.firstName,
                second_name: payload.lastName,
                patronymic_name: payload.middleName,
                email: payload.email,
                mobile_phone: payload.phone.replace(/[()-]/g, '')
            };

            return axios.post(url, userData, context.getters.maintenanceConfig).then(res => {
                context.commit('setMaintenanceClientInfo', payload)
            });
        },

        checkVehicleInfo(context, payload) {
            const brandId = context.state.brandId;
            const data = payload.data
            const urlParams = {
                brandId: brandId,
                mileage: data.mileage
            };

            if(data.vin) {
                urlParams.vin = data.vin;
            } else {
                urlParams.model = data.model.id;
                urlParams.airType = data.air.id;
                urlParams.fuelType = data.fuel.id;
                urlParams.engineCapacity = data.engineSize.id;
                urlParams.modelYear = data.year.id;
            }

            const url = maintenanceSending.sendVehicle(urlParams);

            return axios.post(url, null, context.getters.maintenanceConfig)
                .then(res => {
                    context.commit('setMaintenanceVehicleInfo', {
                        data: res.data.vin_info,
                        entryType: payload.entryType
                    });
                })
                .catch(err => {
                    reject()
                })
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/Maintenance.js